import { parseQueryParamsObject } from "@robe/core-utils";
import { SubCategory } from "@robe/core-types/category";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { fillMissingLocalizedCategoriesNames } from "./utils";

export const getSubCategoryCompletion = (id: string, term: string, locale: string, core: XcoreCore): BaseApiRequest<SubCategory[]> =>
  core
    .fetch(`/api/category/subcategory/completion/${id}${parseQueryParamsObject({ term, locale })}`)
    .then((res) => res.json())
    .then(fillMissingLocalizedCategoriesNames);
